/*global google*/
import React from "react";

import Map from "./Map/Map";
import MarkerClusterer from "./Map/MarkerClusterer";

const CustomMap = ({ markerOptions, maxZoom = 13, zoom, center }) => {
  return (
    <Map
      mapTypeId={google.maps.MapTypeId.ROADMAP}
      maxZoom={maxZoom}
      style={{ flexGrow: "1", height: "100%" }}
      zoom={zoom} 
      center={center}
    >
      <MarkerClusterer markerOptions={markerOptions} maxZoom={maxZoom} />
    </Map>
  );
};

export default CustomMap;
